// redux/chatSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  messages: [],        // chat messages
  searchTerm: "",      // search input from TopBar
};

const chatSlice = createSlice({
  name: "chat",
  initialState,
  reducers: {
    setMessages: (state, action) => {
      state.messages = action.payload;
    },
    setSearchTerm: (state, action) => {
      state.searchTerm = action.payload;
    },
    addMessage: (state, action) => {
      state.messages.push(action.payload);
    },
    clearMessages: (state) => {
      state.messages = [];
    },
  },
});

export const { setMessages, setSearchTerm, addMessage, clearMessages } = chatSlice.actions;
export default chatSlice.reducer;
